import dom from '../../../wrapper/DomWrapper';

export default (width, container) => dom
  .getElementWidth(container) >= width;
